import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import api from "../lib/api";

export default function Footer() {
  const [contact, setContact] = useState({ email: "heasupportteam@gmail.com", phone: "904-450-2883", address: "Yulee, FL" });
  useEffect(() => { api.get("/site-content/contact_info").then((r) => r.data.value && setContact(r.data.value)).catch(() => {}); }, []);

  return (
    <footer className="mt-24 bg-navy text-white">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-16 lg:grid-cols-4 lg:px-8">
        <div className="lg:col-span-1">
          <Logo dark />
          <p className="mt-4 max-w-xs text-sm text-white/60">Learning Beyond the Classroom. Hands-on experiences and real-world learning for families.</p>
        </div>
        <div>
          <h4 className="eyebrow text-white/50">Explore</h4>
          <ul className="mt-4 space-y-2 text-sm text-white/80">
            <li><Link to="/experiences" className="hover:text-exploration">Experiences</Link></li>
            <li><Link to="/memberships" className="hover:text-exploration">Memberships & Pricing</Link></li>
            <li><Link to="/step-up-booking" className="hover:text-exploration">Step Up Booking</Link></li>
            <li><Link to="/media-merchandise" className="hover:text-exploration">Media & Merchandise</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="eyebrow text-white/50">Families</h4>
          <ul className="mt-4 space-y-2 text-sm text-white/80">
            <li><Link to="/register" className="hover:text-exploration">Create Account</Link></li>
            <li><Link to="/login" className="hover:text-exploration">Parent Login</Link></li>
            <li><Link to="/about" className="hover:text-exploration">About H.E.A.</Link></li>
            <li><Link to="/contact" className="hover:text-exploration">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="eyebrow text-white/50">Contact</h4>
          <ul className="mt-4 space-y-2 text-sm text-white/80">
            <li><a href={`mailto:${contact.email}`} data-testid="footer-email" className="hover:text-exploration">{contact.email}</a></li>
            <li><a href={`tel:${(contact.phone || "").replace(/[^0-9+]/g, "")}`} data-testid="footer-phone" className="hover:text-exploration">{contact.phone}</a></li>
            <li className="text-white/60">{contact.address}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-5 py-6 text-xs text-white/40 lg:px-8">
          © {new Date().getFullYear()} Homeschool Enrichment Academy. A growing local enrichment organization.
        </div>
      </div>
    </footer>
  );
}
